import styled from 'styled-components';
import { tokens } from '@welbe/web-design-system';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	background-color: ${tokens.color_white};
	padding: 3vh 2vw 5vh 2vw;
`;

export const Footer = styled.div`
	display: flex;
	width: 100%;
	flex-direction: row;
	padding: 0 50px;
	align-items: center;
	height: 100px;

	a p {
		display: flex;
		justify-content: center;

		svg {
			margin-left: 10px;
		}
	}
`;

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	padding: 0px 40px;
`;

export const Separator = styled.hr`
	border: 1px solid ${tokens.color_ink_lightest};
	margin: 40px 0;
`;

export const SectionLogo = styled.div`
	position: absolute;
	top: -30px;
	left: 50%;
	transform: translateX(-50%);
	width: 60px;
	height: 60px;
	background-color: ${tokens.color_primary};
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;

	& > svg {
		display: grid;
		place-items: center;
		width: 60px;
		height: 60px;

		& > path {
			fill: #fff;
		}
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	flex: 1;
	gap: 20px;

	padding-right: 30px;
`;

export const ParagraphContainer = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;

	height: 40px;
	margin: 34px 0 20px 0;
`;
